const menus = [
	// {
	// 	title: '동행축제',
	// 	code: 'menu1',
	// 	path: '/ko/info',
	// 	isActive: false,
	// 	isSubActive: false,
	// 	children: [
	// 		{
	// 			title: '행사정보',
	// 			path: '/ko/info',
	// 			isTargetBlank: false,
	// 		},
	// 		// 임시로 주석요청 사용하지 않는 건 아님 - 현업 요청
	// 		{
	// 			title: '행사연혁',
	// 			path: '/ko/info/campnHistory',
	// 			isTargetBlank: false,
	// 		},
	// 		{
	// 			title: '홍보물',
	// 			path: '/ko/promotion',
	// 			isTargetBlank: false,
	// 		},
	// 	],
	// },
	// {
	// 	title: '행사정보',
	// 	code: 'menu2',
	// 	path: '/ko/info',
	// 	isActive: true,
	// },
	// {
	// 	title: '행사연혁',
	// 	code: 'menu3',
	// 	path: '/ko/info/campnHistory',
	// 	isActive: true,
	// },
	// {
	// 	title: '동행제품',
	// 	code: 'menu4',
	// 	path: '/ko/products/category',
	// 	isActive: false,
	// 	isSubActive: false,
	// 	children: [
	// 		{
	// 			title: '제품 카테고리',
	// 			path: '/ko/products/category',
	// 			isTargetBlank: false,
	// 		},
	// 		{
	// 			title: '인기제품',
	// 			path: '/ko/products/popular',
	// 			isTargetBlank: false,
	// 		},
	// 	],
	// },
	// {
	// 	title: '지역행사',
	// 	code: 'menu5',
	// 	path: '/ko/festival',
	// 	isActive: false,
	// },
	// {
	// 	title: '이벤트',
	// 	code: 'menu6',
	// 	path: '/ko/event/eatingOut',
	// 	// path: '/ko/event/sns-pr',
	// 	isActive: false,
	// 	// isSubActive: false,
	// 	children: [
	// 		{
	// 			title: '외식 활성화',
	// 			path: '/ko/event/eatingOut',
	// 			isTargetBlank: false,
	// 		},
	// 		{
	// 			title: '오늘 식사 한 끼, 밖에서 먹어요',
	// 			path: '/ko/event/dineOut',
	// 			isTargetBlank: false,
	// 		},
	// 		{
	// 			title: '출석체크',
	// 			path: '/ko/event/check',
	// 			isTargetBlank: false,
	// 		},
	// 		{
	// 			title: '랭킹게임',
	// 			path: '/ko/event/ranking',
	// 			isTargetBlank: false,
	// 		},
	// 		{
	// 			title: '찜하기',
	// 			path: '/ko/event/dibs',
	// 			isTargetBlank: false,
	// 		},
	// 		{
	// 			title: '구매후기',
	// 			path: '/ko/event/sns',
	// 			isTargetBlank: false,
	// 		},
	// 		{
	// 			title: '공공배달앱 이용후기',
	// 			path: '/ko/event/delivery',
	// 			isTargetBlank: false,
	// 		},
	// 		{
	// 			title: '동행 숨결 챌린지',
	// 			path: '/ko/event/challenge',
	// 			isTargetBlank: false,
	// 		},
	// 	],
	// },
	// {
	// 	title: '동행뉴스',
	// 	code: 'menu7',
	// 	path: '/ko/news/list',
	// 	isActive: false,
	// },
];

export default menus;
